var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.18 15.1A15.09 15.09 0 1 0 12.73 30V19.45H8.9V15.1h3.83v-3.32c0-3.79 2.25-5.87 5.7-5.87 1.65 0 3.38.29 3.38.29v3.7h-1.9c-1.88 0-2.46 1.17-2.46 2.36v2.83h4.18l-.66 4.36h-3.52V30a15.1 15.1 0 0 0 12.73-14.9Z"
  })));
};
export default SvgFacebook;